/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { spacing } from '../../shared/theme/spacing';
import { ticketColors } from '../../shared/theme/ticketColors';
import { settingsStyles } from '../../settings/screens/settingsScreen.styles';
import { dismissEmployeeWelcome, isEmployeeWelcomeDismissed } from '../application/onboardingUiStorage';
import { useDismissableCard } from './useDismissableCard';

type Props = {
  userId: string;
};

export function EmployeeWelcomeCard({ userId }: Props) {
  const { visible, dismissing, onDismiss } = useDismissableCard(
    userId,
    isEmployeeWelcomeDismissed,
    dismissEmployeeWelcome,
  );

  if (!visible) return null;

  return (
    <View style={settingsStyles.card}>
      <View style={styles.titleRow}>
        <Ionicons name="people-outline" size={22} color={ticketColors.ink2} />
        <Text style={settingsStyles.cardTitle}>Bienvenido al equipo</Text>
      </View>
      <Text style={settingsStyles.caption}>
        Ya estás en el equipo. Elegí el local y usá lo que te habilitaron.
      </Text>
      <TouchableOpacity
        onPress={() => void onDismiss()}
        disabled={dismissing}
        style={settingsStyles.secondaryButton}
        accessibilityRole="button"
        accessibilityLabel="Entendido"
      >
        <Text style={settingsStyles.secondaryButtonText}>Entendido</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
  },
});
